import React from 'react'
import { css } from '@emotion/react'

import EmptyStateImage from '../../assets/images/list/empty-state.inline.svg'

const emptyStateWrapperCss = (theme) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 65px;

  > h3 {
    font-weight: ${theme.font.bold};
    font-size: 20px;
    margin-bottom: 0;
  }
  > p {
    font-size: 15px;
    margin-top: 10px;
  }
`

const EmptyState = () => (
  <div css={emptyStateWrapperCss}>
    <EmptyStateImage />
    <h3>Nothing to show</h3>
    <p>Please adjust filters and / or select another category.</p>
  </div>
)

export default EmptyState
